








































































import Vue from "vue";
import { v4 as uuidv4 } from "uuid";
import VueNumeric from "vue-numeric";
import { InputMask } from "@/shared/interfaces/InputMask.interface";
export default Vue.extend({

    components: {
        VueNumeric: VueNumeric
    },

    props: {
        minus: {
            type: Boolean,
            default: false
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: false
        },
        name: {
            type: String,
            required: false,
            default: "number"
        },
        ariaLabelTooltip: {
            type: String,
            required: false,
            default: ""
        },
        input: {
            type: [String, Number],
            default: 0
        },
        inputLabel: {
            type: String,
            required: false,
            default: ""
        },
        inputTooltip: {
            type: Boolean,
            required: false,
            default: false
        },
        inputDescription: {
            type: String,
            required: false,
            default: ""
        },
        inputOptional: {
            type: Boolean,
            required: false,
            default: true
        },
        errorMessage: {
            type: String,
            required: false,
            default: null
        },
        minValue: {
            type: Number,
            default: null
        },
        maxValue: {
            type: Number,
            default: null
        },
        valueType: {
            type: String,
            required: false,
            default: "surface"
        },
        gridLayout: {
            type: String,
            required: false,
            default: ""
        },
        specificId: {
            type: String,
            required: false,
            default: ""
        },
        noMargin: {
            type: Boolean,
            required: false,
            default: false
        },
        isRowItem: {
            type:Boolean,
            required: false,
            default: false
        }
    },

    data: function() {
        return {
            internalInput: this.input,
            groupFocused: false,
            uniqueId: (this.specificId !== "") ? this.specificId : uuidv4() as string
        };
    },

    computed: {
        options: function(): InputMask {
            return this.getInputMask(this.valueType);
        },
        setMinValue: function(): number {
            let minValue = this.minValue;
            if(minValue === null) {
                minValue = this.options.min;
            }
            return minValue;
        },
        setMaxValue: function(): number {
            let maxValue = this.maxValue;
            if(maxValue === null) {
                maxValue = this.options.max;
            }
            return maxValue;
        },
        className: function(): string {
            let className = "input--text";
            if (this.errorMessage) {
                className += " input--error";
            }
            if (this.gridLayout !== "") {
                className += " " + this.gridLayout;
            }

            return className;
        }
    },

    watch: {
        inputTo: function() {
            this.internalInput = this.input;
        },
        internalInput: function() {
            this.$emit("update-value", this.internalInput);
        }
    },
    methods: {
        onFocus: function () {
            this.groupFocused = true;
        },
        onBlur: function () {
            this.groupFocused = false;
            this.$emit("blur");
        }
    }

});
